import { omitBy, isNil, get } from 'lodash';

const response = (data: any) => {

    const { results } = data.data;


    const lat = get(results, '[0].geometry.location.lat', null)?.toString();
    const lon = get(results, '[0].geometry.location.lng', null)?.toString();

    return omitBy({
        status: data.data.status,
        coordinates: {
            lat,
            lon
        },
        error: data.error,
    }, isNil);
}

export default response;

